<script setup>
import { reactive, inject, onMounted, onUnmounted } from 'vue';
const props = defineProps({
    uid: { type: String, default: () => crypto.randomUUID() },
    selected: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    label: { type: String },
    value: { default: undefined },
})

const { select, registerOption, unregisterOption } = inject('dropdown', { registerOption: () => {}, unregisterOption: () => {}})

const option = reactive({
    uid: props.uid,
    selected: props.selected,
    disabled: props.disabled,
    label: props.label ?? props.value,
    value: props.value,
})

onMounted(() => { registerOption(option) })
onUnmounted(() => { unregisterOption(option) })
</script>

<template>
    <div
        @click="select(option.uid)"
        class="dropdown-option dropdown__option"
        :class="{
            'dropdown__option-selected': option.selected
        }"
    >
        <slot v-bind="{ ...props }">{{ props.label }}</slot>
    </div>
</template>

<style lang="scss">
@use "@/scss/framework" as *;

</style>
